import { render, staticRenderFns } from "./AboutTalentPlan.vue?vue&type=template&id=d4d1f146&scoped=true"
import script from "./AboutTalentPlan.vue?vue&type=script&lang=js"
export * from "./AboutTalentPlan.vue?vue&type=script&lang=js"
import style0 from "./AboutTalentPlan.vue?vue&type=style&index=0&id=d4d1f146&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d1f146",
  null
  
)

export default component.exports